/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const featuredChallengeItemSchema = z.object({
  slug: z.string(),
  title: z.string(),
  cefrLevel: z.string(),
});

export type IFeaturedChallengeItem = z.infer<typeof featuredChallengeItemSchema>;

export const listFeaturedChallengesV1ResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(featuredChallengeItemSchema),
});

export type IListFeaturedChallengesV1Response = z.infer<
  typeof listFeaturedChallengesV1ResponseSchema
>;
